import React from 'react'
import CTAButton from "../HomePage/Button"
import { TypeAnimation } from 'react-type-animation'

const CodeBlocks = ({
    position, heading, subheading, ctabtn1, ctabtn2, codeblock, backgroudGradient, codeColor
}) => {
  return (
    <div
      className={`flex flex-col ${position} my-12 justify-between gap-10 lg:my-16 lg:items-start`}
    >
      <div className="flex min-w-0 w-full max-w-xl flex-col gap-6 p-2 lg:w-[48%] lg:max-w-none lg:p-4">
        {heading}
        <div className="text-richblack-300 px-1 text-sm font-bold md:text-lg lg:px-0">
          {subheading}
        </div>

        <div className="mt-2 flex flex-wrap gap-4 px-1 lg:px-0">
          <CTAButton active={ctabtn1.active} linkto={ctabtn1.linkto}>
            {ctabtn1.btnText}
          </CTAButton>
          {ctabtn2 ? (
            <CTAButton active={ctabtn2.active} linkto={ctabtn2.linkto}>
              {ctabtn2.btnText}
            </CTAButton>
          ) : null}
        </div>
      </div>

      {/* Code panel: never wrap line gutter away from code (fixes stray “11”) */}
      <div className="glass h-fit w-full min-w-0 shrink-0 py-3 lg:w-[min(100%,500px)]">
        <div className="flex flex-nowrap flex-row text-sm">
          <div className="flex w-10 shrink-0 flex-col text-center font-inter font-bold text-richblack-400">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((n) => (
              <p key={n}>{n}</p>
            ))}
          </div>

          <div
            className={`relative min-h-[200px] min-w-0 flex-1 pr-2 font-mono font-bold ${codeColor}`}
          >
            <div className={backgroudGradient} />
            <div className="relative z-[1]">
              <TypeAnimation
                sequence={[codeblock, 5000, codeblock]}
                repeat={Infinity}
                cursor
                style={{
                  whiteSpace: "pre-line",
                  display: "block",
                  overflowX: "hidden",
                  fontSize: "16px",
                }}
                omitDeletionAnimation
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CodeBlocks
